import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';
import { HubService } from 'src/app/pages/hubs/common/HubService';
//import { InboundComponent } from 'src/app/pages/queue/inbound/inbound.component';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
let self;

let _userDetails: any;
@Injectable({ providedIn: 'root' })
export class CommunicationHub extends Hub {
    //public InboundCallEvents: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    static INBOUND_CALL = 'communicationHub_inboundCall';
    static CALL_ENDED = 'communicationHub_callEnded';
    static MESSAGE_RECEIVED = 'communicationHub_messageReceived';
    static REMOTE_LOGGEDOFF = 'communicationHub_remoteLoggedOff';
    static RECEIVE_LIVETRANSCRIPT = 'communicationHub_receiveLiveTranscript';
    static RECEIVE_CALLANALYTICS = 'communicationHub_receivecallAnaltics';
    static SENDCALL_FAILUREALERT = 'communicationHub_sendcallfailurealert';
    static HUB_Name: string = 'CommunicationHub';
    // private isUserSet: boolean = false;
    static _hubService;


    constructor(private hubManager: HubManager, private hubService: HubService) {
        super();
        self = this;
        CommunicationHub._hubService = hubService;
        // inboundComponent: InboundComponent
        // hubManager.CONNECTIONSTARTED.subscribe(userLoginDet => {
        hubManager.hubManagerEvents.subscribe((value: any) => {
            if (value && value.eventName == 'CONNECTIONSTARTED') {
                //if (!this.hubManager.getTMHubJoinedStatus()) {
                    _userDetails = value.data;
                    this.eLoginHandler();
                //}
            }
        });
    }
     
    //@InboundAttribute
    receiveMessage(callID: any, message: any) {
        console.log('Communicationhub->receiveMessage:' + message); 
        CommunicationHub._hubService.setCallEvents({ eventName: 'MESSAGE_RECEIVED', data: message }); 
    }

    sendcallfailurealert(callID: any, message: any) {
        console.log('Communicationhub->sendcallfailurealert:' + message);
        CommunicationHub._hubService.setCallEvents({ eventName: 'SENDCALL_FAILUREALERT', data: message });
    }
    
    //@InboundAttribute
    inboundCall(client: string, callID: any, number: any, name: any, queue: any, queuedTime: any, conference: any) {
        const callDetails: { key: string; value: string }[] = [
            { key: 'client', value: client },
            { key: 'callID', value: callID },
            { key: 'number', value: number },
            { key: 'name', value: name },
            { key: 'queue', value: queue },
            { key: 'queuedTime', value: queuedTime },
            { key: 'conference', value: conference },
        ];
        CommunicationHub._hubService.setCallEvents({ eventName: 'INBOUND_CALL', data: callDetails });
        console.log('Inbound Call Received-' + callID);
        
    }

    //@InboundAttribute
    callEnded(client: string, callID: any) {
        console.log('callEnded method called,callid:' + callID);
        //this.inboundComponent.CALL_Ended.emit();
        CommunicationHub._hubService.setCallEvents({ eventName: 'CALL_Ended', data: null });
        //    if (this.QBRSecurity().clientShortName() == client) {
        //        this.dispatchEvent(CommunicationHub.CALL_ENDED, callID);
        //    }
    }

    //@InboundAttribute
    remoteLogoffNotification(client: string, msg: any) {
        CommunicationHub._hubService.setCallEvents({ eventName: 'REMOTE_LOGGEDOFF', data: msg });
    }
    receiveLiveTranscript(client: string, msg: any) {
        CommunicationHub._hubService.setCallEvents({ eventName: 'RECEIVE_LIVETRANSCRIPT', data: msg });
    }
    receiveCallAnalytics(client: string, msg: any) {
        CommunicationHub._hubService.setCallEvents({ eventName: 'RECEIVE_CALLANALYTICS', data: msg });
    }
    private eLoginHandler() {
        this.joinHub();
    }
    private joinHub() {
        //console.log('CommunicationHub Joined', _userDetails);
        self.join(
            _userDetails.find(i => i.key === 'ClientShortName').value,
            'Telemarketing',
            _userDetails.find(i => i.key === 'Username').value,
            _userDetails.find(i => i.key === 'UserEmail').value,
            _userDetails.find(i => i.key === 'UserID').value
        );
        this.hubManager.setTMHubJoinedStatus(true);
        this.hubService.setIsHubStarted(false);
    }

    public sendSoftphoneDeviceIssue(
        client: string,
        message: any
    ): void {
        console.log(
            'CommunicationHub -> sendSoftphoneDeviceIssue received',
            { client, message }
        );

        this.hubService.setCallEvents({
            eventName: 'SENDDEVICE_FAILUREALERT',
            data: message
        });
    }
}
